import Model from '$dependencies/Model';

const FIELDS = {
	id: { type: String, default: '', identifier: true },
	uuid: { type: String, default: '' },
	url: { type: String, default: '' },
	file: { type: Blob, default: null },
	filename: { type: String, default: '' },
	filemime: { type: String, default: '' },
	filesize: { type: Number, default: 0 },
	image_style_uri: { type: String, default: '' },
	original: { type: String, default: '' },
	originalUrl: { type: String, default: '' },
};

export default class PhotoModel extends Model {
	constructor(args = {}) {
		args = Object.assign({}, args);
		args.fields = FIELDS;
		super(args);
	}

	post(data) {
		if (this.file && this.file.size > 0) {
			const headerBackup = Object.assign({}, this._config.headers);
			this.setConfig('headers', {
				Accept: 'application/json',
				'Content-Disposition': `file; filename="${this.filename || 'photo'}.jpg"`,
				'Content-Type': 'application/octet-stream',
			});
			return super.post(this.file).finally(() => {
				this._config.headers = headerBackup;
			});
		}

		return super.post(data);
	}

	parse(data) {
		return super.parse(normalizePhoto(data));
	}

	destroy() {}
}

export function normalizePhoto(data) {
	if (!data) return {};
	if (Array.isArray(data)) {
		return normalizePhoto(data[data.length - 1] || {});
	}
	if (data.data) {
		return normalizePhoto(data.data);
	}

	const attributes = data.attributes || {};
	const uri = attributes.uri;
	const uriUrl = uri && typeof uri === 'object' ? uri.url : uri;
	const styleUri = data.image_style_uri || attributes.image_style_uri || '';
	const id = data.uuid || data.id || '';
	const url = data.url || uriUrl || '';
	const originalUrl = data.originalUrl || data.original_url || data.original || url;

	return {
		id,
		uuid: data.uuid || id,
		url,
		original: data.original || originalUrl || url,
		originalUrl,
		filename: data.filename || attributes.filename || '',
		filemime: data.filemime || attributes.filemime || '',
		filesize: Number(data.filesize || attributes.filesize || 0) || 0,
		image_style_uri: flattenImageStyleUri(styleUri),
		file: data.file instanceof Blob ? data.file : null,
	};
}

export function extractPhotoList(data) {
	if (!data) return [];
	if (Array.isArray(data)) return data;
	if (Array.isArray(data.images)) return data.images;
	if (Array.isArray(data.data)) return data.data;
	if (data.data) return [data.data];
	return [data];
}

function flattenImageStyleUri(value) {
	if (!value) return '';
	if (typeof value === 'string') return value;
	if (typeof value === 'object') {
		return value.community_logo || Object.values(value)[0] || '';
	}
	return '';
}
